import React, { useEffect, useState } from 'react'
import { RCard, RCardHeader, RCardBody } from '@components/card'
import { RAnchorPrimary } from '@components/anchor'
import { RLoadingData } from '@components/loading'
import { RDataTable } from '@components/table'
import ResourceService from '@services/resource.service'
import columns from './columns'

const Pegawai = () => {
    const url = "/master-pegawai"
    const paginate = 10
    const [data, setData] = useState([]);
    const [result, setResult] = useState(null);
    const [table, setTable] = useState({
        url: url,
        params: {
            paginate: paginate
        },
        attr: {
        },
        default: {
            url: url,
            paginate: paginate,
        }
    });

    useEffect(() => {
        let mounted = true;
        const getData = () => {
            ResourceService.table(table.url, table.params)
            .then(
                ({ data, ...res }) => {
                    if (mounted) {
                        const { data: getData, ...attrs } = data

                        setTable({
                            ...table,
                            attr: {
                                ...table.attr,
                                ...attrs
                            }
                        })
                        setData(getData)
                        setResult(res)
                    }
                },
                (error) => {
                    if (mounted) {
                        setResult(error)
                    }
                }
            )
        }
        getData()
        return () =>  {
            mounted = false
        }
    }, [table.refresh])

  return (
    <RLoadingData result={result}>
        <RCard>
            {table.attr && table.attr.ops_create && <RCardHeader>
                <RAnchorPrimary href={`${url}/create`}>Tambah</RAnchorPrimary>
            </RCardHeader>}

            <RCardBody>
                <RDataTable columns={columns} data={data} table={table} setTable={setTable} />
            </RCardBody>
        </RCard>
    </RLoadingData>
  )
}

export default Pegawai

